// extracted by mini-css-extract-plugin
export default {"brdr":"people_brdr__Gcmuy","secondcolor":"people_secondcolor__ZRJi5"};